<template>
  <div>
    <div class="group relative">
      <!-- IMAGE -->
      <div class="aspect-[4/3] w-full overflow-hidden">
        <AppImage
          class="
            size-full object-cover transition-transform duration-500 ease-in-out
            group-hover-focus:scale-[1.2]
          "
          :src="data.image"
        />
      </div>

      <!-- TEXT -->
      <div class="pt-6 md:pt-7">
        <div class="text-grey-300 typo-body-sm">
          <!-- Category -->
          <span>{{ data.category.title }}</span>
          <span class="px-[0.5em]">&bull;</span>
          <!-- Date -->
          <time :datetime="data.date">{{ dateFormatted }}</time>
        </div>

        <div class="mt-1 flex justify-between gap-5 md:mt-2 md:gap-10">
          <!-- Title -->
          <h3 class="line-clamp-3 font-semibold typo-h6">
            <span>
              {{ data.heading }}
            </span>
            <span v-if="data.heading && data.sub_heading"> – </span>
            <span v-if="data.sub_heading">{{ data.sub_heading }}</span>
          </h3>
          <!-- Link -->
          <NuxtLink :to="data.url" class="mr-1 mt-1 h-max after:absolute after:inset-0 after:z-10">
            <IconArrowRight
              class="
                size-7 -rotate-45 transition-[transform,color] duration-300 ease-in-out
                group-hover-focus:-translate-y-1 group-hover-focus:translate-x-1
                group-hover-focus:text-primary-900
              "
            />
          </NuxtLink>
        </div>
      </div>
    </div>

    <!-- Tags -->
    <ul v-if="showTags" class="mt-4 flex flex-wrap gap-2">
      <li v-for="tag in data.tags" :key="tag.id">
        <AppTag :active="route.query.tag === tag.slug">
          {{ tag.title }}
        </AppTag>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  showTags: {
    type: Boolean,
    default: true,
  },
})

const route = useRoute()

const dateFormatted = useDateFormatted(props.data, {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
})
</script>
